import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import p5 from 'p5';

import styles from './Lines.styl';

import { fastStroke, fastBackground } from '../../util/color';

const noise = p5.prototype.noise;

// const randomInt = (min, max) => min + Math.round((max - min) * Math.random());
const randomInt = (() => {
  let val = 0;
  return (min, max) => min + Math.round((max - min) * noise(val += 1));
})();

const pointsPerLine = 100;

class Line {
  constructor(height, priorLine) {
    this.points = priorLine ?
      priorLine.points.map(point => ({
        x: point.x + randomInt(4, 5),
        y: point.y,
      })) :
      [...new Array(pointsPerLine)].map((undef, idx) => ({
        x: 0,
        y: idx * (height / pointsPerLine),
      })).concat({ x: 0, y: height });
    this.minX = this.points.reduce((min, point) => Math.min(min, point.x), Infinity);
    window.line = this;
    this.visible = 0;
  }

  draw(p) {
    this.visible += 1;
    p.line(
      this.points[this.visible - 1].x,
      this.points[this.visible - 1].y,
      this.points[this.visible].x,
      this.points[this.visible].y
    );
    // Drawing will be complete when we run out of points
    return ! this.points[this.visible + 1];
  }

  drawAll(p) {
    for (let i = 1; i < this.points.length; i += 1) {
      p.line(
        this.points[i - 1].x,
        this.points[i - 1].y,
        this.points[i].x,
        this.points[i].y
      );
    }
    return true;
  }
}

class Lines extends PureComponent {

  constructor(props) {
    super(props);
    this.lines = [];
  }

  componentDidMount() {
    this.sketch = this.init();
  }

  componentDidUpdate() {
    // Redraw
    this.sketch.remove();
    this.sketch = this.init();
  }

  init() {
    const { width, height } = this.props;
    const setCurrentLine = (line) => { this.currentLine = line; };
    const getCurrentLine = () => this.currentLine;
    setCurrentLine(new Line(height));

    /* eslint-disable no-param-reassign */
    // eslint-disable-next-line new-cap
    return new p5((p) => {
      let stroke = 'black';

      p.setup = function setup() {
        p.createCanvas(width, height);
        fastBackground(p, 'white');
        fastStroke(p, stroke);
        p.frameRate(60);
      };

      p.draw = function draw() {
        const currentLine = getCurrentLine();

        if (currentLine.minX >= width) {
          stroke = (stroke === 'black' ? 'white' : 'black');
          fastStroke(p, stroke);
          p.strokeWeight(stroke === 'white' ? 4 : 1);
          setCurrentLine(new Line(height));
          return;
        }

        // Draw, which returns a boolean indicating whether we need to add a new line
        if (currentLine.drawAll(p)) {
          setCurrentLine(new Line(height, currentLine));
        }
      };

    }, this.container);
    /* eslint-enable no-param-reassign */
  }

  render() {
    return (
      <div className={styles.Lines} ref={node => (this.container = node)} />
    );
  }
}

Lines.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default Lines;



// WEBPACK FOOTER //
// ./components/Lines/Lines.jsx